"use client";

import { useEffect, type FC } from "react";
import { Bell } from "lucide-react";
import { Button } from "@shadcn/ui/button";
import { Popover, PopoverContent, PopoverTrigger } from "@shadcn/ui/popover";
import { Badge } from "@shadcn/ui/badge";
import RecentAlerts from "@/src/presentation/components/recent-alerts";
import AlarmStore from "@/src/application/store/alarm-store";
import useInject from "@/src/presentation/hooks/useInject";
import { observer } from "mobx-react-lite";

const NotificationBell: FC = observer(() => {
  const alarmStore = useInject(AlarmStore);

  useEffect(() => {
    alarmStore.fetchCount();
    const interval = setInterval(() => alarmStore.fetchCount(), 30000); // 30s
    return () => clearInterval(interval);
  }, [alarmStore]);

  const count = alarmStore.activeCount;

  return (
    <Popover>
      <PopoverTrigger asChild>
        <Button
          variant="ghost"
          size="icon"
          className="relative size-11 rounded-full border border-transparent transition-all hover:border-slate-200 hover:bg-slate-100"
        >
          <Bell className="size-6 text-slate-700" />
          {count > 0 && (
            <Badge className="absolute -top-1 -right-1 flex h-6 min-w-[24px] items-center justify-center rounded-full border-2 border-white bg-red-600 px-1 text-xs font-black text-white shadow-md">
              {count > 99 ? "99+" : count}
            </Badge>
          )}
        </Button>
      </PopoverTrigger>
      <PopoverContent
        className="w-[380px] border-2 border-slate-100 p-0 shadow-2xl"
        align="end"
        sideOffset={12}
      >
        <RecentAlerts className="border-0 shadow-none" />
      </PopoverContent>
    </Popover>
  );
});

export default NotificationBell;
